var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 25,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#facebook-dark_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#472179",
  d: "M2.599 24.133v-11.16H.922c-.51 0-.922-.39-.922-.868V8.571c0-.476.415-.865.922-.865h1.677V4.864C2.599 2.178 4.917 0 7.775 0h4.303c.51 0 .922.388.922.867V4.4c0 .479-.413.866-.922.866H9.531c-.29 0-.53.226-.53.498v1.944l3.02-.002c.51.033.923.356.923.865-.062.822-.14 1.65-.217 2.475l-.105 1.131c-.04.447-.44.795-.918.795H9.001v11.161c0 .476-.413.866-.92.866L3.52 25c-.508 0-.922-.389-.922-.867m1.204-.263h3.994V11.84h3.648l.27-3.005H7.797v-3.07c0-.9.776-1.63 1.734-1.63h2.265V1.131H7.775c-2.194 0-3.972 1.671-3.972 3.732v3.973H1.204v3.003h2.6z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "facebook-dark_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h13v25H0z"
})))));
export default SvgFacebookDark;